import { render, staticRenderFns } from "./InputHeader.vue?vue&type=template&id=428a895e&scoped=true"
import script from "./InputHeader.vue?vue&type=script&lang=ts"
export * from "./InputHeader.vue?vue&type=script&lang=ts"
import style0 from "./InputHeader.vue?vue&type=style&index=0&id=428a895e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428a895e",
  null
  
)

export default component.exports